import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalPublicProperties, ModalResult, DocumentSignedModalComponent as ModalComponent } from './document-signed-modal.component';

@Injectable({ providedIn: 'root' })
export class DocumentSignedModalService {
  constructor(private modalService: ModalService) {}

  open(properties?: ModalPublicProperties, options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, properties, options);
  }
}
